/* eslint-disable import/no-unresolved */
import dayjs from "dayjs";
import { FormikProps } from "formik";
import { useEffect } from "react";
import { AssignmentDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { findKeysByValue } from "src/helpers/FormDetails/ProposalDetails/resources";
import CustomDatePicker from "src/shared/CustomDatePicker";
import CustomSelect from "src/shared/CustomSelect";
import CustomTextField from "src/shared/CustomTextField";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  formik: FormikProps<AssignmentDetails>;
  assignmentMefFields: any;
}

function AssignmentClause({ formik, assignmentMefFields }: Props) {
  const occupationData =
    useAppSelector((state) => state?.masterdata_reducer?.assignmentOccupationDetails) || {};
  const masterData = useAppSelector((state) => state.masterdata_reducer);

  useEffect(() => {
    formik?.setFieldValue(
      "occupationCode",
      findKeysByValue(masterData.occupationDetails, formik?.values?.occupation)
    );
  }, [formik?.values?.occupation]);
  return (
    <div className="space-y-6">
      <span className="font-montserrat text-black text-base font-bold mb-6 flex">
        Assignment Clause
      </span>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
        {assignmentMefFields?.assignor?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.assignor?.required}
            label={assignmentMefFields?.assignor?.label}
            disabledField={assignmentMefFields?.assignor?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.assignor}
            name="assignor"
            error={formik.errors.assignor}
            touched={formik.touched.assignor}
          />
        )}
        {assignmentMefFields?.assignorJoint?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.assignorJoint?.required}
            label={assignmentMefFields?.assignorJoint?.label}
            disabledField={assignmentMefFields?.assignorJoint?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.assignorJoint}
            name="assignorJoint"
            error={formik.errors.assignorJoint}
            touched={formik.touched.assignorJoint}
          />
        )}
        {assignmentMefFields?.assignorName?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.assignorName?.required}
            label={assignmentMefFields?.assignorName?.label}
            disabledField={assignmentMefFields?.assignorName?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.assignorName}
            name="assignorName"
            error={formik.errors.assignorName}
            touched={formik.touched.assignorName}
          />
        )}
        {assignmentMefFields?.assigmentAt?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.assigmentAt?.required}
            label={assignmentMefFields?.assigmentAt?.label}
            disabledField={assignmentMefFields?.assigmentAt?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.assigmentAt}
            name="assigmentAt"
            error={formik.errors.assigmentAt}
            touched={formik.touched.assigmentAt}
          />
        )}
        {assignmentMefFields?.signedDate?.visible && (
          <CustomDatePicker
            minDate={dayjs(new Date())}
            maxDate={dayjs(new Date()).add(1, "day")}
            value={formik.values?.signedDate}
            label={assignmentMefFields?.signedDate?.label}
            setFieldValue={formik.setFieldValue}
            name="signedDate"
            error={formik.errors.signedDate}
            touched={formik.touched.signedDate}
            setFieldTouched={formik.setFieldTouched}
          />
        )}
        {assignmentMefFields?.place?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.place?.required}
            label={assignmentMefFields?.place?.label}
            disabledField={assignmentMefFields?.place?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.place}
            name="place"
            error={formik.errors.place}
            touched={formik.touched.place}
          />
        )}
        {assignmentMefFields?.reasonForAssigment?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.reasonForAssigment?.required}
            label={assignmentMefFields?.reasonForAssigment?.label}
            disabledField={assignmentMefFields?.reasonForAssigment?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.reasonForAssigment}
            name="reasonForAssigment"
            error={formik.errors.reasonForAssigment}
            touched={formik.touched.reasonForAssigment}
          />
        )}
      </div>

      <span className="font-montserrat text-black text-base font-bold mb-6 flex">
        Witness Details
      </span>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
        {assignmentMefFields?.witnessName?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.witnessName?.required}
            label={assignmentMefFields?.witnessName?.label}
            disabledField={assignmentMefFields?.witnessName?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.witnessName}
            name="witnessName"
            error={formik.errors.witnessName}
            touched={formik.touched.witnessName}
          />
        )}
        {assignmentMefFields?.address?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.address?.required}
            label={assignmentMefFields?.address?.label}
            disabledField={assignmentMefFields?.address?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.address}
            name="address"
            error={formik.errors.address}
            touched={formik.touched.address}
          />
        )}
        {assignmentMefFields?.pincode?.visible && (
          <CustomTextField
            requiredStar={assignmentMefFields?.pincode?.required}
            label={assignmentMefFields?.pincode?.label}
            disabledField={assignmentMefFields?.pincode?.disabled}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.pincode}
            name="pincode"
            error={formik.errors.pincode}
            touched={formik.touched.pincode}
          />
        )}
        {assignmentMefFields?.occupation?.visible && (
          <CustomSelect
            requiredStar={assignmentMefFields?.occupation?.required}
            label={assignmentMefFields?.occupation?.label}
            options={Object.values(occupationData)}
            onChange={formik.handleChange}
            setFieldTouched={formik.setFieldTouched}
            name="occupation"
            value={formik.values.occupation}
            error={formik.errors.occupation}
            touched={formik.touched.occupation}
          />
        )}
      </div>
    </div>
  );
}

export default AssignmentClause;
